import { FieldPath, UseFormReturn } from "react-hook-form";

import { OptionalLabel } from "@/components/OptionalLabel";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import {
  DateTimePicker,
  DateTimePickerProps,
} from "./DateTimePicker";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

import { cn } from "@/lib/utils";

export const FormDateTimePicker = <T extends Record<string, unknown>>({
  className,
  description,
  disabled,
  fieldName,
  form,
  label,
  minuteStep,
  optional,
  placeholder,
}: {
  className?: string;
  description?: string;
  disabled?: boolean;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  label: string;
  minuteStep?: DateTimePickerProps["minuteStep"];
  optional?: boolean;
  placeholder?: string;
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("text-slate-700", className)}>
            <Row className="items-baseline gap-2">
              <FormLabel>
                {label}
                {optional && <OptionalLabel className="ml-1.5" />}
              </FormLabel>
              {description && (
                <Text variant="muted" className="text-xs">
                  {description}
                </Text>
              )}
            </Row>
            <FormControl>
              <DateTimePicker
                value={(field.value ?? "") as string}
                onChange={field.onChange}
                minuteStep={minuteStep}
                disabled={disabled}
                placeholder={placeholder}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
